import { EntityUnionType } from 'common/types/entities/EntityInterface'
import ServerPage from 'server/types/ServerPageInterface'

export const migrateMultipleCommand = <P>({
  page,
  structureTypes,
  migrateFunction,
}: {
  page: ServerPage
  structureTypes: string[]
  migrateFunction: (entity: P) => (entity: P) => EntityUnionType
}): [ServerPage, boolean] => {
  let isChanged = false
  try {
    const entities = Object.values(page.content.entities).reduce<
      Record<string, EntityUnionType>
    >((prev, entity) => {
      if (structureTypes.includes(entity.type)) {
        isChanged = true
      }

      prev[entity.id] = structureTypes.includes(entity.type)
        ? migrateFunction(entity as P)(entity as P)
        : entity

      return prev
    }, {})

    return [
      {
        ...page,
        content: {
          ...page.content,
          entities,
        },
      },
      isChanged,
    ]
  } catch (e) {
    console.error('--error--', e)

    return [page, false]
  }
}
